/**
 * ---------------------------------------------------------------------------
 * PDP gallery "View Similar" tag
 * ---------------------------------------------------------------------------
 *
 * Replaces the image-zoom button in the product gallery (see
 * snippets/product-gallery.liquid) with a small pill-shaped tag. On click it
 * scrolls the page down to the "You may also like" / related products
 * section, instead of opening the image lightbox.
 *
 * The button markup uses `is="view-similar-tag-button"` (extends <button>) so
 * it keeps native button semantics/keyboard support, and a
 * `data-scroll-target` attribute holding the CSS selector to scroll to. The
 * related-products section is marked with `data-related-products-section`
 * (see sections/related-products.liquid) so this keeps working even if the
 * section is re-ordered, renamed, or its Shopify section id changes.
 *
 * Safe to delete: removing this file, its <script> tag in layout/theme.liquid,
 * and reverting snippets/product-gallery.liquid restores the stock zoom
 * button behaviour.
 */

(function () {
  'use strict';

  var DEFAULT_TARGET_SELECTOR = '[data-related-products-section]';

  // Roughly matches the sticky header height so the section title isn't
  // hidden underneath it after scrolling.
  function getScrollOffset() {
    var header = document.querySelector('sticky-header, [data-sticky-header], header');
    var height = header ? header.getBoundingClientRect().height : 0;

    return height + 16;
  }

  function scrollToTarget(target) {
    if (!target) return false;

    var top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();

    window.scrollTo({ top: top, behavior: 'smooth' });

    return true;
  }

  var ViewSimilarTagButton = window.customElements.get('view-similar-tag-button')
    ? null
    : class extends HTMLButtonElement {
        constructor() {
          super();
          this.addEventListener('click', this._onButtonClicked);
        }

        _onButtonClicked() {
          var selector = this.getAttribute('data-scroll-target') || DEFAULT_TARGET_SELECTOR;
          var target = document.querySelector(selector);

          // Fall back to the default selector if a more specific one wasn't found.
          if (!target && selector !== DEFAULT_TARGET_SELECTOR) {
            target = document.querySelector(DEFAULT_TARGET_SELECTOR);
          }

          scrollToTarget(target);
        }
      };

  if (ViewSimilarTagButton) {
    window.customElements.define('view-similar-tag-button', ViewSimilarTagButton, { extends: 'button' });
  }
})();